import Button from '@mui/material/Button';
import { Wrapper } from './styled';
import { useState } from 'react';
import Create from './Create';
import Update from './Update';

enum VALUES {
    CREATE = 'create',
    UPDATE = 'update',
}

const Admin = () => {
    const [selected, setSelected] = useState<VALUES | undefined>(undefined);

    const handleBack = () => setSelected(undefined);

    return (
        <Wrapper mt={4}>
            {selected ? (
                selected === VALUES.CREATE ? (
                    <Create handleBack={handleBack} />
                ) : (
                    <Update handleBack={handleBack} />
                )
            ) : (
                <>
                    <Button variant='contained' onClick={() => setSelected(VALUES.CREATE)}>
                        Создать пользователя
                    </Button>
                    <Button variant='contained' onClick={() => setSelected(VALUES.UPDATE)}>
                        Редактировать пользователя
                    </Button>
                </>
            )}
        </Wrapper>
    );
};

export default Admin;
